interface SuperAdminStubPageProps {
  title: string;
  icon: string;
  desc: string;
}

export default function SuperAdminStubPage({ title, icon, desc }: SuperAdminStubPageProps) {
  return (
    <div style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      minHeight: "100%",
      padding: "2rem",
    }}>
      <div style={{
        background: "var(--clr-surface)",
        backdropFilter: "var(--clr-blur)",
        border: "1px solid var(--clr-border)",
        borderRadius: 20,
        padding: "3rem 2.5rem",
        maxWidth: 420,
        width: "100%",
        textAlign: "center",
        boxShadow: "var(--clr-shadow)",
      }}>
        <div style={{
          fontSize: "3rem",
          marginBottom: "1rem",
          color: "var(--clr-org-primary)",
          lineHeight: 1,
        }}>
          {icon}
        </div>
        <h1 style={{
          fontSize: "1.4rem",
          fontWeight: 700,
          color: "var(--clr-text)",
          margin: "0 0 0.625rem",
        }}>
          {title}
        </h1>
        <p style={{
          fontSize: "0.875rem",
          color: "var(--clr-text2)",
          margin: "0 0 1.5rem",
          lineHeight: 1.6,
        }}>
          {desc}
        </p>
        <span style={{
          display: "inline-block",
          padding: "0.3rem 0.875rem",
          borderRadius: 20,
          background: "var(--clr-org-primary, #0891b2)22",
          color: "var(--clr-org-primary, #0891b2)",
          fontSize: "0.75rem",
          fontWeight: 700,
          letterSpacing: "0.5px",
          textTransform: "uppercase",
        }}>
          Próximamente
        </span>
      </div>
    </div>
  );
}
